<template>
  <v-form
    fast-fail
    @submit.prevent="saveData"
    class="edit-conductor"
    v-click-outside="outsideCancelAction"
  >
    <h2 class="title mb-2">
      {{
        !isCreate
          ? $t("editConductorModalComponent.title.edit")
          : $t("editConductorModalComponent.title.create")
      }}
    </h2>
    <v-text-field
      v-model="userData.fullname"
      :label="$t('editConductorModalComponent.labels.name')"
    ></v-text-field>
    <v-text-field
      v-model="userData.username"
      :label="$t('editConductorModalComponent.labels.userName')"
      autocomplete="new-user"
    ></v-text-field>
    <v-text-field
      type="password"
      v-model="userData.password"
      autocomplete="new-password"
      :label="
        isCreate
          ? $t('editConductorModalComponent.labels.password')
          : $t('profile.newPassword')
      "
    >
      <template v-slot:append-inner v-if="isCreate">
        <v-tooltip :text="$t('users.table.modals.passwordTooltip')">
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props" icon="$info" class="pb-1"></v-icon>
          </template>
        </v-tooltip>
      </template>
    </v-text-field>
    <v-select
      :label="$t('editConductorModalComponent.labels.partner')"
      :items="this.partners"
      item-title="name"
      item-value="id"
      v-model="userData.partner"
    ></v-select>
    <div class="is-active-section">
      <p class="is-active-label">
        {{ $t("editConductorModalComponent.labels.isActive") }}
      </p>
      <v-checkbox v-model="userData.active"></v-checkbox>
    </div>
    <div class="btn-row mt-6">
      <v-btn @click="cancelAction">
        {{ $t("editConductorModalComponent.buttons.cancel") }}
      </v-btn>
      <v-btn v-if="!isCreate" class="mb-2" @click="userDelete" color="red">
        {{ $t("editConductorModalComponent.buttons.delete") }}
      </v-btn>
      <v-btn :disabled="!visibleButton" color="primary" @click="saveData">
        {{ $t("editConductorModalComponent.buttons.save") }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "EditConductorModal",
  props: {
    user: {
      type: Object,
      required: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userData: {
        id: undefined,
        fullname: "",
        username: "",
        partner: undefined,
        password: "",
        active: false,
      },

      defaultUsername: "",

      partners: [],
      isSaveEnabled: false,
    };
  },
  mounted() {
    this.getPartnerList();
    if (!this.isCreate) {
      this.getUserData();
    }
  },
  methods: {
    ...mapActions({
      getPartners: "users/getPartners",
    }),
    getNameById(array, id) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].id === id) {
          return array[i].name;
        }
      }
      return null;
    },
    setPartner() {
      this.userData.partner = this.getNameById(
        this.partnersWithId,
        this.user.par_id
      );
    },
    getUserData() {
      this.userData.id = this.user.id;
      this.userData.fullname = this.user.fullname;
      this.userData.username = this.user.username;
      this.userData.partner = this.user.partner;
      this.userData.active = this.user.active;

      this.defaultUsername = this.user.username;
    },
    getPartnerList() {
      this.getPartners()
        .then((response) => {
          this.partners = response.result.map((partner) => {
            return { id: partner.id, name: partner.par_name };
          });
          if (!this.isCreate) {
            this.userData.partner = this.user.par_id;
          }
        })
        .catch(() => {});
    },
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },
    outsideCancelAction(event) {
      const clickedElement = event.target;
      const classList = clickedElement.classList;

      if (classList.contains("v-overlay__scrim")) {
        this.cancelAction();
      }
    },
    saveData() {
      if (this.isCreate) {
        const createPayload = {
          id: this.userData.id,
          fullname: this.userData.fullname,
          username: this.userData.username,
          password: this.userData.password,
          par_id: this.userData.partner,
          active: this.userData.active,
        };
        this.$emit("createNewUser", createPayload);
      } else {
        const createPayload = {
          id: this.userData.id,
          fullname: this.userData.fullname,
          username:
            this.userData.username === this.defaultUsername
              ? null
              : this.userData.username,
          password: this.userData.password,
          par_id: this.userData.partner,
          active: this.userData.active,
        };
        this.$emit("saveUser", createPayload);
      }
      this.emitter.emit("closeModal");
    },
    userDelete() {
      const payload = {
        title: this.$t("conductors.table.deleteModal.title"),
        subTitle: this.$t("conductors.table.deleteModal.subTitle"),
        userId: this.userData.id,
      };
      this.emitter.emit("showConfirmModal", payload);
    },
  },
  computed: {
    visibleButton() {
      return (
        (this.isCreate &&
          this.userData.partner &&
          this.userData.username !== "" &&
          this.userData.fullname !== "" &&
          this.userData.password !== "" &&
          this.userData.password.length >= 6) ||
        (!this.isCreate &&
          this.userData.fullname !== "" &&
          this.userData.username !== "" &&
          (this.userData.username !== this.user.username ||
            this.userData.fullname !== this.user.fullname ||
            this.userData.active !== this.user.active ||
            this.userData.partner !== this.user.par_id ||
            this.userData.password.length >= 6))
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-conductor {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }

  .is-active-section {
    display: flex;
    .is-active-label {
      padding-top: 16px;
    }
  }

  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
